import { Injectable } from '@angular/core';

declare global {
  interface Window {
    $crisp: any[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class CrispService {
  private ensureInit(): void {
    window.$crisp = window.$crisp || [];
  }

  showChat(): void {
    this.ensureInit();
    window.$crisp.push(['do', 'chat:show']);
  }

  hideChat(): void {
    this.ensureInit();
    window.$crisp.push(['do', 'chat:hide']);
  }
}
